import React from "react"; //eslint-disable-line
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getSchedule } from "@resto-guru/common-js";
import firebase from "datastore/database";
import { isEqual } from "lodash";
import { DateTime } from "luxon";

import { getSchedulePeriods, isWithinSchedule, getNextBound } from "util";
import { useBusinessUid } from "common/hooks";
import { selectShiftsArr } from "selectors/shifts";
import { setBusinessHours } from "./context/actions";
import { useLocalDispatch } from "./context";

function useSchedule(selectedDate) {
  const businessUid = useBusinessUid();
  const params = useParams();
  // const shifts = useSelector(selectShiftsArr, isEqual);
  const [loading, setLoading] = useState(true);
  const [schedule, setSchedule] = useState({});

  const day = React.useMemo(() => DateTime.fromJSDate(selectedDate), [
    selectedDate,
  ]);
  const date = React.useMemo(() => day.startOf("day").toJSDate(), [day]);
  const withSpecialDay = false; // We don't want to show special days in the schedule

  useEffect(() => {
    let mounted = true;

    async function getShifts() {
      if (!businessUid) return;
      const uid = businessUid ? businessUid : params[0].split("/")[1];
      const schedule = await getSchedule(firebase, uid, date, withSpecialDay);
      if (mounted) {
        setSchedule(schedule);
        setLoading(false);
      }
    }

    getShifts();
    return () => {
      mounted = false;
    };
  }, [businessUid, params, date, withSpecialDay]);

  return { loading, schedule };
}

export default function useGeneralHours() {
  const localDispatch = useLocalDispatch();
  const date = React.useMemo(() => new Date(), []); // Only create once
  const { loading, schedule } = useSchedule(date);

  const periods = React.useMemo(() => getSchedulePeriods(schedule), [schedule]);
  const open = React.useMemo(() => isWithinSchedule(moment(), periods), [
    periods,
  ]);
  const nextTiming = React.useMemo(() => getNextBound(periods), [periods]);

  useEffect(() => {
    localDispatch(setBusinessHours({ open, nextTiming, schedule, loading }));
  }, [localDispatch, open, nextTiming, schedule, loading]);

  return { open, nextTiming, schedule, loading };
}
